var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('figure',{staticClass:"organization-avatar"},[(_vm.logoSrc)?_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.logoSrc,"srcset":_vm.logoSrcSet}})]):_c('div',{staticClass:"letter-logo",attrs:{"data-length":_vm.letters.length}},[_vm._v("\n        "+_vm._s(_vm.letters)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }